<template>
    <Head :title="'Mortgage Calculator for St. Johns Homebuyers'" >
        <link rel="canonical" href="https://www.ginabetbeze.com/mortgage-calculator" />
        <meta name="description" content="Use Gina Betbeze’s mortgage calculator for St. Johns County homebuyers. Estimate payments to plan your real estate investment wisely." />
    </Head>
    <!-- Simple Blurb -->

    <PageContent
        :id="'mortgage-calculator-page'"
        :breadcrumbs="['Home', 'Mortgage Calculator']"
        :header="''"
    >
        <div class="w-full">
            <MortgageCalculator/>
        </div>
    </PageContent>
</template>
<script setup>
import PageContent from "../Components/Layout/PageContent.vue";
import HomeLayout from "../Layouts/HomeLayout.vue";
import MortgageCalculator from "@/Components/PageContent/MortgageCalculator.vue"
import { Head, Link, usePage } from "@inertiajs/vue3";

defineOptions({ layout: HomeLayout });
const props = defineProps({
    title: {
        type: String,
        required: true,
    },
});
</script>
